const { on } = window.ivent;

on(document, 'ready', () => {
	const bar = document.querySelector('#announcement-bar-root');

	if (bar) {
		let height = bar.getBoundingClientRect().height;

		const observer = new ResizeObserver((entries) => {
			entries.forEach((entry) => {
				if (entry.contentRect.height !== height) {
					document.body.style.setProperty(
						'--announcement-bar--height',
						`${entry.contentRect.height}px`,
					);

					height = entry.contentRect.height;
				}
			});
		});

		observer.observe(bar);
	}
});
